import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Automatyczne rozliczenia',
  buttons: {
    add_subscription: 'Dodaj subskrypcję',
    suspend_company: 'Zawieś restaurację',
    restore_company: 'Przywróć restaurację',
    edit_suspend: 'Edytuj info o zawieszeniu',
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
  },
  modals: {
    suspend_company: {
      title: 'Czy na pewno zawiesić {{company}}?',
      description:
        'Spowoduje to anulowanie wszystkich aktywnych subskrypcji, wyłączenie zamówień na żywo i powiadomienie właściciela restauracji e-mailem. Przed potwierdzeniem wybierz powód.',
      suspense_reason: {
        label: 'Wybierz powód zawieszenia',
        placeholder: 'Wybierz powód',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Zamknięcie lub zmiana właściciela',
          [SUSPENSE_REASON.LowRoi]: 'Niski ROI',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Wrażliwość na ceny/opłaty',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Brak integracji/luki produktowe',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Słaby onboarding/aktywacja',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Niezadowolenie z pomocy technicznej',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Przejście do konkurencji/marketplace/własne rozwiązanie',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Rozczarowanie wynikami marketingu',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Falsche Registrierung / Daten',
        },
        validation: {
          required: 'Proszę wybrać powód',
        },
      },
      suspense_competitor: {
        label: 'Do jakiego konkurenta przeszli?',
        placeholder: 'Proszę wybrać konkurenta',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Inne',
        },
        validation: {
          required: 'Proszę wybrać konkurenta',
        },
      },
      suspense_reason_notes: {
        label: 'Dodatkowy kontekst (opcjonalnie)',
        placeholder: 'Podaj dodatkowe szczegóły',
      },
    },
    restore_company: {
      title: 'Czy na pewno przywrócić {{company}}?',
      description: 'Nadal będziesz musiał ręcznie utworzyć subskrypcję i włączyć zamówienia na żywo.',
    },
  },
  toasts: {
    failed_to_load_data: 'Błąd ładowania szczegółów subskrypcji',
    failed_to_suspend_company: 'Nie udało się zawiesić restauracji. Skontaktuj się z pomocą techniczną',
    failed_to_restore_company: 'Nie udało się przywrócić restauracji. Skontaktuj się z pomocą techniczną',
  },
};
